import RecordingFee from 'src/models/RecordingFee';
import React, { useEffect, useState } from 'react';
import useFetch from 'use-http';
import RecordingFeeCard from './RecordingFeeCard';
import State from 'src/models/State';
import County from 'src/models/County';
import { SelectItem } from 'src/models/common/SelectItem';
import RecordingFeeOptions from 'src/models/RecordingFeeOptions';
import Button from 'src/components/controls/forms/redesign/FormButton';
import Invoice from 'src/models/leasing/Invoice';
import CollapsibleSection from 'src/components/common/CollapsibleSection';

interface IRecordingFeeListDialogStateProps {
    clientNumber: number;
    projectNumber: number;
    invoiceNumber: string;
    invoice: Invoice;
    isSubmitting: boolean;
    countyId: number;
    stateId: number;
    setCurrentStep: (index: number) => void;
    onCancel: () => void;
    submitWithFees: (invoice: Invoice) => void;
}

const RecordingFeeListDialog = (props: IRecordingFeeListDialogStateProps) => {
    const [recordingFeeData, setRecordingFeeData] = useState<RecordingFee[]>([]);
    const [states, setStates] = useState<State[]>([]);
    const [counties, setCounties] = useState<County[]>([]);
    const [dispositions, setDispositions] = useState<SelectItem[]>([]);
    const [indexTypes, setIndexTypes] = useState<SelectItem[]>([]);
    const [recordingFeeTotal, setRecordingFeeTotal] = useState<number>(0);

    const { get, response } = useFetch();

    const loadRecordingFeeData = async () => {
        if (props.invoice?.id && props.invoice?.id > 0) {
            let data: RecordingFee[] = await get(`v1.0/clients/${props.clientNumber}/projects/${props.projectNumber}/recordingFee/by-invoice/${props.invoice.id}`);

            if (response.ok) {
                let recTotal = 0;
                data.forEach(recFee => {
                    recTotal += recFee.recordingFeeAmount;
                });

                setRecordingFeeTotal(recTotal);
                setRecordingFeeData(data);
            }
        } else {
            setRecordingFeeData([]);
        }
    };

    const getRecordingFeeOptions = async () => {
        let data: RecordingFeeOptions = await get(`v1.0/clients/${props.clientNumber}/projects/${props.projectNumber}/recordingFee/recording-fee-options`);

        if (response.ok) {
            setStates(data.states);
            setCounties(data.counties);
            setDispositions(data.dispositions);
            setIndexTypes(data.indexTypes);
            loadRecordingFeeData();
        }
    };

    useEffect(() => {
        getRecordingFeeOptions();
    }, []);

    const updateTotals = (index: number, value: number) => {
        let currentRecords = recordingFeeData;
        let recTotal: number = 0;

        if (!!currentRecords[index]) {
            currentRecords[index].recordingFeeAmount = value;
            setRecordingFeeData(currentRecords);
        } else {
            recTotal += parseFloat(value + '');
        }
        
        for (let i = 0; i < recordingFeeData.length; i++) {
            recTotal += parseFloat(recordingFeeData[i].recordingFeeAmount + '');
        }

        setRecordingFeeTotal(recTotal);
    };

    const addRecordingFee = () => {
        let rfArray = [...recordingFeeData];
        let newRec = new RecordingFee();
        newRec.stateId = props.stateId;
        newRec.countyId = props.countyId;

        rfArray.push(newRec);

        setRecordingFeeData(rfArray);
    };

    const displayRecordingFeeTotal = () => {
        return (
            <div>
                <div className="form-row right-align">
                    <div>Fee Total: {recordingFeeTotal}</div>
                </div>
            </div>
        );
    };

    const displayRecordingFees = () => {
        if (recordingFeeData.length > 0) {
            return <div style={{ overflow: 'scroll', maxHeight: '15%'}}>
                {recordingFeeData.map((rf: RecordingFee, i: number) => {
                    return (
                        <div key={i} className="filter-collapsible">
                            <CollapsibleSection title={`Recording Fee: ${rf.id ? rf.id : 'New'}`}>
                                <RecordingFeeCard
                                    recordingFee={rf}
                                    index={i}
                                    clientNumber={props.clientNumber}
                                    projectNumber={props.projectNumber}
                                    invoiceId={props.invoice?.id}
                                    invoiceNumber={props.invoiceNumber}
                                    states={states}
                                    counties={counties}
                                    indexTypes={indexTypes}
                                    dispositions={dispositions}
                                    submitListener={props.isSubmitting}
                                    updateRecordFees={(v: number) => updateTotals(i, v)}
                                    onCloseDialog={() => props.onCancel()}
                                />
                            </CollapsibleSection>
                        </div>
                    );
                })} 
            </div>;
        } else {
            return <div>No Recording Fees</div>;
        }
    };

    return (
        <div style={{ width: '85vw', maxHeight: '50vh', overflow: 'auto' }}>
            <div style={{ display: 'flex' }}>
                <div className="mr-2" style={{ width: '100%' }}>
                    <div>Invoice # {props.invoiceNumber}</div>
                </div>
            </div>
            {displayRecordingFees()}
            <br />
            {displayRecordingFeeTotal()}
            <div style={{ display: 'flex' }}>
                <div style={{ padding: '1rem' }}>
                    <Button text="Return to Invoice" intent="primary" onClick={() => props.setCurrentStep(0)} />
                </div>
                <div style={{ padding: '1rem' }}>
                    <Button text="Add Fee" intent="primary" onClick={() => addRecordingFee()} />
                </div>
                <div style={{ padding: '1rem' }}>
                    <Button text="Submit Invoice" intent="primary" onClick={() => props.submitWithFees(props.invoice)} />
                </div>
                <div style={{ padding: '1rem' }}>
                    <Button text="Cancel" intent="primary" onClick={() => props.onCancel()} />
                </div>
            </div>
        </div>
    );
};

export default RecordingFeeListDialog;


// WEBPACK FOOTER //
// ./src/components/invoicing/components/RecordingFeeListDialog.tsx